import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgEco(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M16.6425 1.3481C16.1712 0.79022 15.2424 0.924591 14.9528 1.59608C14.2741 3.16962 13.1159 4.34597 11.4192 5.13709C8.29545 6.59364 5.58594 7.14071 4.2523 10.7805C3.2885 13.4109 3.73975 16.2103 5.21981 18.3558C9.61625 16.2234 12.6048 13.0079 14.2603 8.72173C14.4437 8.24669 14.9801 8.00934 15.4584 8.1916C15.9366 8.37386 16.1755 8.9067 15.992 9.38174C13.8011 15.0544 9.18862 18.8708 3.62895 21.079C3.11479 21.2832 2.86464 21.8628 3.07022 22.3735C3.2758 22.8843 3.85926 23.1328 4.37342 22.9286C5.76829 22.3745 7.0759 21.7483 8.2952 21.0497C12.7315 23.3147 18.0848 21.0381 20.0162 16.5371C22.3477 11.1038 20.2497 5.61852 16.6425 1.3481Z", fill: "currentColor" })));
}
export default SvgEco;
